import Enum from '@/modules/core/app/helpers/Enum';

export class ModelHasLiabilityCategory extends Enum {
  static CO_OWNER: string = 'co_owner';
  static CREDITOR: string = 'creditor';
}
